import cn from 'classnames';
import { type KeyboardEvent, useRef } from 'react';

import styles from './CloseButton.module.css';

interface CloseButtonProps {
    onClose: (open: boolean) => void;
    className?: string;
}

export const CloseButton = ({ onClose, className }: CloseButtonProps) => {
    const closeButtonRef = useRef<HTMLButtonElement>(null);

    const handleCloseClick = () => {
        onClose(false);
    };

    const handleKeyDown = (event: KeyboardEvent<HTMLButtonElement>) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleCloseClick();
        }
    };

    return (
        <button
            type="button"
            className={cn(styles['close-button'], className)}
            ref={closeButtonRef}
            aria-label="Lukk"
            onClick={handleCloseClick}
            onKeyDown={handleKeyDown}>
            <w-icon name="Close" size="medium" aria-hidden />
        </button>
    );
};
